// extracted by mini-css-extract-plugin
export default {"link":"header_link__xp8Z0","avatar":"header_avatar__AVQMU","avatar_grid":"header_avatar_grid__aJ3Zu","online":"header_online__L8F6k","status":"header_status__NAAmU"};